export enum FileReportValidationStatusEnum {
  OK = 'OK',
  WITH_WARNINGS = 'WITH_WARNINGS',
  WITH_ERRORS = 'WITH_ERRORS',
}
